<template lang="pug">
  vm-prompt(@vm-cancel="close" @vm-accept="saveInsurer" @vm-close="close" @vm-action="deleteRecordConfirm(newRecord)" :vm-action="newRecord.deleted_at" :vm-action-text="$t('strings.delete')" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-buttons-hidden="newRecord.deleted_at" :vm-is-valid="!$v.newRecord.$invalid && fileValidate" :vm-active="isModalVisible" :vm-title='getTitle')
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12" v-shortcuts="[{ shortcut: [ 'enter', ], callback: saveRecord, push: true, focus: true, disabled: false }]")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-input(autofocus :placeholder='$t("insurers.name")' :danger="$v.newRecord.name.$invalid && $v.newRecord.name.$model" :danger-text="$t('validation.required', { attribute: $t('insurers.name') })" v-model="newRecord.name" :label='$t("insurers.name")')
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          uploader(v-model="fileList" :autoUpload="false" :limit="1" :title="$t('insurers.thumbnail')")
          span.muted {{ $t('strings.help_image_size', {attribute: '160 x 60 pixeles'}) }}
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12" v-if="this.$route.path == '/pages/sinister-detail/4'")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-input(autofocus :placeholder='$t("insurers.phone")' v-model="newRecord.phone1" :label='$t("insurers.phone")')
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-input(autofocus :placeholder='$t("insurers.phone")' v-model="newRecord.phone2" :label='$t("insurers.phone")')
</template>

<script>
import ModalMixin1 from '@/mixins/ModalMixin1'
import { required } from 'vuelidate/lib/validators' // Ver documentacion
import { createNamespacedHelpers } from 'vuex'
import Uploader from 'vux-uploader-component'
const { mapGetters, mapActions } = createNamespacedHelpers('Insurers')

export default {
  name: 'ModalInsurers',
  components: {
    Uploader
  },
  mixins: [ModalMixin1],
  props: {
    newRecord: {
      type: Object,
      default: () => {}
    },
    isAdd: {
      default: true,
      type: Boolean
    }
  },
  data: () => ({
    fileList: []
  }),
  validations () {
    return {
      newRecord: {
        name: {
          required
        }
      }
    }
  },
  computed: {
    ...mapGetters(['isModalVisible']),
    fileValidate () {
      return this.fileList.length > 0
    },
    getTitle () {
      return this.isAdd ? this.$t('insurers.add') : this.$t('insurers.edit')
    }
  },
  watch: {
    isModalVisible (flag) {
      if (flag) {
        if (this.newRecord.thumbnail) this.fileList.push({ url: this.newRecord.thumbnail, name: this.newRecord.name })
      } else if (!flag) {
        this.fileList = []
        this.newRecord = {
          id: '',
          name: '',
          thumbnail: '',
          file: []
        }
      }
    }
  },
  methods: {
    ...mapActions([
      'addRecord',
      'editRecord',
      'deleteRecord',
      'setModalVisible',
      'loadCatalog',
      'addInsurer',
      'updateInsurer',
      'isModalinsurerVisible'
    ]),
    async saveInsurer () {
      if (this.isAdd) {
        await this.addRecord({
          ...this.newRecord,
          page_id: this.$route.params.id,
          file: this.fileList[0].blob
        })
      } else {
        await this.editRecord({
          ...this.newRecord,
          file: this.fileList[0].blob ? this.fileList[0].blob : null
        })
      }
    }
  }
}
</script>
